import { RESET_ALL_POINTS } from '../types';

export default directionType => ({
  type: RESET_ALL_POINTS,
  directionType,
});
